export default __webpack_public_path__ + "static/media/checkmark_bullet.bc6de1a8.svg";